import FormSection from './FormSection';
import { hintCls, controlCls } from './formStyles';
import { LIMITS } from '../../visitorConstants';

const NotesField = ({ form, set }) => (
    <FormSection
        icon="mdi:note-text-outline"
        title="Internal notes"
        hint="Visible to society staff only — never shown to the visitor"
    >
        <textarea
            rows={3}
            value={form.notes || ''}
            onChange={e => set('notes', e.target.value)}
            maxLength={LIMITS.notes}
            placeholder="e.g. Prefers evening slots. Always asks for Flat B-402."
            className={`${controlCls(false)} tw-resize-none`}
        />
        <p className={hintCls}>{(form.notes || '').length}/{LIMITS.notes}</p>
    </FormSection>
);

export default NotesField;
